export const environment = {
  production: true,
  googleMapsAPIKey: 'AIzaSyBdsdEWFwJz5NZEuReHf4pYnpTprn-KznY',
    apiUrl:'https://cdbdataaceess.fml.co.za/'
};
